import React, { useEffect, useState } from "react";
// primeReact
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
// context
import { useContextSimulator } from "../../SimulatorContext";
import { formatCurrency } from "../../../../../../utils/formatCurrency";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const OneTimeInstallment = () => {
  const {
    simulatorData,
    oneTimeParcelValue, setOneTimeParcelValue,
    oneTimeParcelDate, setOneTimeParcelDate,
  } = useContextSimulator();


  return (
    <>
      <div className="row">
        <div className="col-xl-3 col-md-6 pb-2">
          <label className="mb-3">Parcela Única</label>
          <p className="input">{formatCurrency(oneTimeParcelValue)}</p>
        </div>
        <div className="col-xl-3 col-md-6 pb-2">
          <label className="mb-3">Data Pagamento</label>
          <Calendar
            value={oneTimeParcelDate}
            onChange={(e) => setOneTimeParcelDate(e.value)}
            dateFormat={"dd/mm/yy"}
              mask="99/99/9999"
            className="w-100"
            locale="pt"
            minDate={new Date()}
          />
        </div>
      </div>
    </>
  );
};

export default OneTimeInstallment;
